// extracted by mini-css-extract-plugin
module.exports = {"CompleteButton":"styles_CompleteButton__3TOVR","DeleteButton":"styles_DeleteButton__1FhDX","Icon":"styles_Icon__3yE5R"};